<template>
  <v-card>
    <v-card-title class="headline">
      Información de carabinero
    </v-card-title>
    <v-card-text>
      <v-alert v-if="showAlert" color="warning" type="warning" class="mt-3">
        No hay información de carabinero asociado al local <strong>{{ local.lapCodigo }} - {{ local.local.nombre }}</strong>
      </v-alert>
      <div v-else-if="!data && !showAlert" class="text-center">
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        />
      </div>
      <div v-else>
        <v-simple-table dense>
          <template #default>
            <tbody>
              <tr>
                <td><strong>LOCAL</strong></td>
                <td class="text-left">
                  {{ local.lapCodigo }} - {{ local.local.nombre }}
                </td>
              </tr>
              <tr>
                <td><strong>UNIDAD</strong></td>
                <td class="text-left">
                  {{ data.pclUnidad }}
                </td>
              </tr>
              <tr>
                <td><strong>GRADO</strong></td>
                <td class="text-left">
                  {{ data.pclGrado }}
                </td>
              </tr>
              <tr>
                <td><strong>NOMBRE</strong></td>
                <td class="text-left">
                  {{ data.pclNombre }}
                </td>
              </tr>
              <tr>
                <td><strong>APELLIDO</strong></td>
                <td class="text-left">
                  {{ data.pclApellido }}
                </td>
              </tr>
              <tr>
                <td><strong>TELÉFONO</strong></td>
                <td class="text-left">
                  {{ data.pclTelefono }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </v-card-text>
    <v-card-actions>
      <slot />
    </v-card-actions>
  </v-card>
</template>

<script>
import graphql from '../../utils/graphql';

export default {
  props: {
    local: {
      type: Object,
      default: null
    },
  },
  data: function() {
    return {
      data: null,
      showAlert: false,
    }
  },
  mounted() {
    this.carabineroLocal();
  },
  methods: {
    async carabineroLocal() {
      const {fspCodigo, sedCodigo, lapCodigo} = this.local;
      try {
        const query = {
          query: `
              query ($fspCodigo: Int!, $sedCodigo: Int!, $lapCodigo: Int!) {
                carabinero: carabineroByLocalSedeFase(fspCodigo: $fspCodigo, sedCodigo: $sedCodigo, lapCodigo: $lapCodigo) {
                    pclUnidad
                    pclGrado
                    pclNombre
                    pclApellido
                    pclTelefono
                }
              }
            `,
          variables : {
            fspCodigo,
            sedCodigo,
            lapCodigo,
          }
        };
        const { carabinero } = await graphql.request(query);
        if (!carabinero) {
          this.showAlert = true;
        }
        this.data = carabinero;
      } catch (err) {
        this.$store.commit('error-notification', err.message);
      }
    }
  }
};
</script>
